<template>
    <div class="card card-body shadow-sm mt-0">
      <div class="form-header d-flex justify-content-between align-items-center">
        <h4 class="form-title">{{ route.params.id ? 'Editar Cargo de Funcionário' : 'Novo Cargo de Funcionário' }}</h4>
        <button class="btn btn-secondary btn-sm me-3" @click="voltar">Voltar</button>
      </div>
  
      <BaseForm :isFormValid="isFormValid" :isSubmitting="isSubmitting" @submit="salvarCargo" @cancel="voltar">
        <!-- Dados do Cargo -->
        <FormSection title="Informações do Cargo">
          <InputField
            v-model="cargo.nome"
            label="Nome do Cargo <span class='required'>*</span>"
            id="nome"
            placeholder="Digite o nome do cargo"
            required
            :class="{ 'error-input': errors.nome }"
            width="400px"
          />
          <span v-show="formTouched && errors.nome" class="error-message">{{ errors.nome }}</span>
        </FormSection>
      </BaseForm>
    </div>
  </template>
  
  <script>
  import { reactive, ref, computed, onMounted } from "vue";
  import { useRoute, useRouter } from "vue-router";
  import InputField from "@/components/Layout/InputField.vue";
  import FormSection from "@/components/Layout/FormSection.vue";
  import BaseForm from "@/components/Layout/BaseForm.vue";
  import axios from "@/services/axios";
  
  export default {
    components: { InputField, FormSection, BaseForm },
    setup() {
      const route = useRoute();
      const router = useRouter();
  
      const cargo = reactive({
        id: null,
        nome: "",
      });
  
      const errors = reactive({});
      const formTouched = ref(false);
      const isSubmitting = ref(false);
  
      const validateForm = () => {
        errors.nome = cargo.nome ? "" : "O nome do cargo é obrigatório.";
      };
  
      const isFormValid = computed(() => {
        return cargo.nome.trim() !== '' && !Object.values(errors).some((error) => error);
      });
  
      const novoCargo = () => {
        formTouched.value = false;
        isSubmitting.value = false;
        Object.assign(cargo, {
          nome: "",
        });
        for (const key in errors) {
          if (Object.hasOwn(errors, key)) errors[key] = "";
        }
      };
  
      const salvarCargo = async () => {
        if (isSubmitting.value) return;
  
        validateForm();
  
        if (!isFormValid.value) {
          console.error("O formulário contém erros:", errors);
          return;
        }
  
        isSubmitting.value = true;
        try {
          const method = cargo.id ? "put" : "post";
          const url = cargo.id
            ? `/cadastros/cargos-funcionarios/${cargo.id}`
            : "/cadastros/cargos-funcionarios";
  
          await axios[method](url, {
            nome: cargo.nome,
          });
  
          router.push("/cadastros/cargos-funcionarios");
        } catch (error) {
          console.error("Erro ao salvar cargo:", error);
        } finally {
          isSubmitting.value = false;
        }
      };
  
      const voltar = () => {
        router.push("/cadastros/cargos-funcionarios");
      };
  
      onMounted(async () => {
        const cargoId = route.params.id;
  
        if (cargoId) {
          try {
            const response = await axios.get(`/cadastros/cargos-funcionarios/${cargoId}`);
            Object.assign(cargo, response.data);
          } catch (error) {
            console.error("Erro ao carregar cargo:", error);
          }
        } else {
          novoCargo();
        }
      });
  
      return {
        cargo,
        errors,
        isFormValid,
        formTouched,
        isSubmitting,
        salvarCargo,
        voltar,
        route,
      };
    },
  };
  </script>
  
  <style scoped>
  .card {
    max-width: 90%;
    margin: 0 auto;
  }
  
  .error-input {
    border-color: #dc3545;
  }
  
  .error-message {
    color: #dc3545;
    font-size: 0.875rem;
  }
  </style>
  